// Toggleable filter chip used by the Browse view. Visual conventions mirror
// ModeToggle's pill — ink fill when selected, mist outline when not — but the
// shape is "many siblings, some selected" rather than ModeToggle's binary.
//
// `subLabel` is for chips that pair a Chinese head with pinyin (topic chips);
// other chips (HSK / Profession / Vibe) leave it blank.

import { C } from '@/styles/tokens';

interface FilterChipProps {
  label: string;
  selected: boolean;
  onToggle: () => void;
  subLabel?: string;
  /** Optional accessible name override; defaults to `label`. */
  ariaLabel?: string;
}

export function FilterChip({ label, selected, onToggle, subLabel, ariaLabel }: FilterChipProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={selected}
      aria-label={ariaLabel ?? label}
      onClick={onToggle}
      className="inline-flex items-baseline gap-1.5 px-3 py-1.5 rounded-full ff-body text-[11px] font-semibold transition-all"
      style={{
        background: selected ? C.ink : 'transparent',
        color: selected ? 'white' : C.inkLight,
        border: `1px solid ${selected ? C.ink : C.mist}`,
      }}
    >
      {subLabel ? (
        <>
          <span className="ff-zh-serif text-[13px] tracking-normal">{label}</span>
          <span className="opacity-70 text-[10px]">{subLabel}</span>
        </>
      ) : (
        <span>{label}</span>
      )}
    </button>
  );
}
